import { render, staticRenderFns } from "./video_sel.vue?vue&type=template&id=67ded757&scoped=true"
import script from "./video_sel.vue?vue&type=script&lang=js"
export * from "./video_sel.vue?vue&type=script&lang=js"
import style0 from "./video_sel.vue?vue&type=style&index=0&id=67ded757&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ded757",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ded757')) {
      api.createRecord('67ded757', component.options)
    } else {
      api.reload('67ded757', component.options)
    }
    module.hot.accept("./video_sel.vue?vue&type=template&id=67ded757&scoped=true", function () {
      api.rerender('67ded757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/video/video_sel.vue"
export default component.exports